import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import InvoiceView from "./InvoiceView";
import InvoiceEdit from "./InvoiceEdit";
import {clearInvoiceAttachments, getInvoiceWithoutAttachments, getInvoice, clearInvoice, setInvoiceDrop} from "../../actions/invoices";
import {setProjectDrop} from "../../actions/projects";
import {setContractDrop} from "../../actions/contract";


export function InvoiceSingle(props) {

const invoice = useSelector(state => state.invoices.invoice);
const projectDrop = useSelector(state => state.projects.projectDrop);
const contractDrop = useSelector(state => state.contract.contractDrop);
const invoiceDrop = useSelector(state => state.invoices.invoiceDrop);

const invoiceId = props.match.params.id;

const [render, setRender] = useState(invoiceId === invoice.invoice_id);

const handleReroute = (path) => {
    props.history.push(path)
}


useEffect(() => {
    // LOAD INVOICE TO STORE if it already exists 
    if (invoiceId === "new") {
        invoice.invoice_id && props.clearInvoice();
    } else {
        // For revisions: if revision & already on store, clear any attachments, otherwise, load without attachments
        if (props.match.params.mode === "revise") {
            invoice.invoice_id ? props.clearInvoiceAttachments() : props.getInvoiceWithoutAttachments(invoiceId);
        } else {
             invoice.invoice_id !== invoiceId && props.getInvoice(invoiceId);
        }
    }
}, [props.match.params.id])

// when the correct project data returns
    // make sure the right drops are selected
    // then render the component
useEffect(() => {
    const blankInvoiceReady = invoiceId === "new" && !invoice.invoice_id;
    const existingInvoiceReady = invoice.invoice_id === invoiceId;
    if (existingInvoiceReady) {
        (projectDrop.project_id !== invoice.project_id) && props.setProjectDrop({project_id: invoice.project_id, project_name: invoice.project_name});
        (contractDrop.contract_id !== invoice.contract_id) && props.setContractDrop({project_id: invoice.project_id, project_name: invoice.project_name, contract_name: invoice.contract_name, contract_id: invoice.contract_id});
        (invoiceDrop.invoice_id !== invoice.invoice_id) && props.setInvoiceDrop({project_id: invoice.project_id, project_name: invoice.project_name, contract_name: invoice.contract_name, contract_id: invoice.contract_id, invoice_number: invoice.invoice_number, invoice_id: invoice.invoice_id});
    }
    const dataIsReady = blankInvoiceReady || existingInvoiceReady;
    (dataIsReady && !render) && setRender(true);
}, [invoice.invoice_id])

    return (
        <>
            {render && 
            <>
                {props.match.params.mode === "view"
                ?<InvoiceView handleReroute={handleReroute} match={props.match} />
                :<InvoiceEdit handleReroute={handleReroute} match={props.match} />
                }
            </>
            }
        </>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {
    clearInvoiceAttachments, 
    getInvoiceWithoutAttachments, 
    getInvoice, 
    clearInvoice,
    setProjectDrop,
    setContractDrop,
    setInvoiceDrop,
})(InvoiceSingle);

